import PropTypes from "prop-types";
import { useState } from "react";
import Alert from "app/pages/.shared/Alert/Alert";
import Modal from "react-modal";

// @see https://reactcommunity.org/react-modal/#documentation
const style = {
	overlay: {
		backgroundColor: "rgba(43, 56, 63, .9)",
		zIndex: 6,
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
	content: {
		position: "static",
		border: "none",
		background: "none",
		overflow: "hidden",
		padding: "50px",
	},
};

const INITIAL_STATE = {
	isOpened: false,
	alertProps: {
		title: "",
		message: "",
		buttonLabel: "",
	},
};

export const withAlert = WrappedComponent => {
	const AlertContainer = props => {
		const [{ isOpened, alertProps }, setAlertState] = useState(INITIAL_STATE);

		const closeAlert = () => setAlertState(INITIAL_STATE);

		const showAlert = newAlertProps =>
			setAlertState({ isOpened: true, alertProps: newAlertProps });

		const onConfirm = () => {
			closeAlert();

			if (typeof alertProps.onConfirm === "function") {
				alertProps.onConfirm();
			}
		};

		return (
			<div>
				<WrappedComponent closeAlert={closeAlert} showAlert={showAlert} {...props} />

				<Modal isOpen={isOpened} style={style} onRequestClose={closeAlert}>
					<Alert {...alertProps} onConfirm={onConfirm} />
				</Modal>
			</div>
		);
	};

	AlertContainer.propTypes = {
		onConfirm: PropTypes.func,
		closeAlert: PropTypes.func,
		alert: PropTypes.object,
		renderComponent: PropTypes.func,
	};

	return AlertContainer;
};
